import { render } from "./Fonctions.vue?vue&type=template&id=b74e571c"
import script from "./Fonctions.vue?vue&type=script&lang=js"
export * from "./Fonctions.vue?vue&type=script&lang=js"
script.render = render

export default script